module.exports = __webpack_public_path__ + "static/media/star-lsd.3a285e46.png";